import React from "react";
import "./InvestorsSection.css";

export default function InvestorsSection() {

  return (
    <div className="investor-wrapper">
      <h2 className="investor-title">Used by Top Institutional Investors Around the Global</h2>
      <p className="investor-subtitle">
        Investors from around the world turn to AnnualReports.com for timely insights into global business activity.
      </p>
    </div>
  );
}
